export default "__VITE_ASSET__B0RxVU87__"